/**
 * Is Browser check
 *
 * @package lib-shared
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

export function isBrowser(): boolean {
	return typeof window !== "undefined" && typeof window.document !== "undefined";
}
